// locales
import en from "./locales/en";

export const __ = (key) => {
  return !en[key] ? key : en[key];
};
